import type { ViewData } from '~/types'

import { useApiV2FetchFactory } from '../useApiV2FetchFactory'

export type IncludableField = 'filters'

export const useFetchViews = () => {
  const {
    createGetById,
    createGetAllUnpaginated,
    createCreate,
    createUpdate,
    createDrop,
  } = useApiV2FetchFactory<ViewData, IncludableField>('/v2/views')

  const getAll = createGetAllUnpaginated()
  const getById = createGetById()
  const create = createCreate<App.Data.Payloads.Views.ViewPayload>()
  const update = createUpdate<App.Data.Payloads.Views.ViewPayload>()
  const drop = createDrop()

  return {
    getAll,
    getById,
    create,
    update,
    drop,
  }
}
